// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=Inter:wght@300;400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', sans-serif;
  background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
  min-height: 100vh;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Space Grotesk', sans-serif;
}

.App {
  min-height: 100vh;
}

/* Smooth transitions for interactive elements */
button {
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

button:hover {
  transform: translateY(-1px);
}

button:active {
  transform: translateY(0);
}

input, textarea, select {
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

/* Glass effect for cards */
.glass-effect {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

/* Metaxon AG brand colors - Deep Navy to Cyan */
.metal-gradient {
  background: linear-gradient(135deg, #0A1F33 0%, #00B4D8 100%);
}

.metaxon-primary {
  background: linear-gradient(135deg, #0A1F33 0%, #0096C7 100%);
}

/* Signature canvas styling */
canvas {
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  background: white;
  touch-action: none;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gDAAgD;AAChD;EACE,iFAAiF;AACnF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wDAAwD;AAC1D;;AAEA,2BAA2B;AAC3B;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA,gDAAgD;AAChD;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=Inter:wght@300;400;500;600&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', sans-serif;\n  background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);\n  min-height: 100vh;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: 'Space Grotesk', sans-serif;\n}\n\n.App {\n  min-height: 100vh;\n}\n\n/* Smooth transitions for interactive elements */\nbutton {\n  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\n}\n\nbutton:hover {\n  transform: translateY(-1px);\n}\n\nbutton:active {\n  transform: translateY(0);\n}\n\ninput, textarea, select {\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n/* Glass effect for cards */\n.glass-effect {\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);\n}\n\n/* Metaxon AG brand colors - Deep Navy to Cyan */\n.metal-gradient {\n  background: linear-gradient(135deg, #0A1F33 0%, #00B4D8 100%);\n}\n\n.metaxon-primary {\n  background: linear-gradient(135deg, #0A1F33 0%, #0096C7 100%);\n}\n\n/* Signature canvas styling */\ncanvas {\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  background: white;\n  touch-action: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
